/** URL生成プロパティ */
interface GenerateUrlProps {
  /** ベースのURL */
  baseUrl: string;
  /** USER_CLICK_LIST */
  userClickList: UserClickList;
  /** 現在のページのパス */
  pathname: string;
  /** ログイン状態 */
  loginStatus: boolean;
}

/**
 * URLを生成する関数
 * @param {GenerateUrlProps} props - URL生成プロパティ
 * @returns {string} 生成されたURL
 */
export const generateUrl = ({
  baseUrl,
  userClickList,
  pathname,
  loginStatus,
}: GenerateUrlProps) => {
  if (!pathname.includes('JobSearchList')) {
    return baseUrl;
  }
  const hasParams = baseUrl.includes('?') ? '&' : '?';
  const baseUrlwithParam = `${baseUrl + hasParams + userClickList.param}=${
    loginStatus ? userClickList.value.login : userClickList.value.logout
  }`;
  return baseUrlwithParam;
};

interface UserClickList {
  param: string;
  value: {
    login: string;
    logout: string;
  };
}

export const USER_CLICK_LOGO = {
  param: 'usrclk_searchList',
  value: {
    login: 'PC-loginJobSearchList_floatBunnerArea_toPageTop',
    logout: 'PC-logoutJobSearchList_floatBunnerArea_toPageTop',
  },
} as const;

export const USER_CLICK_HISTORYDETAIL = {
  param: 'usrclk_searchList',
  value: {
    login:
      'PC-loginJobSearchList_floatBannerArea_viewHistory_toviewHistoryDetail',
    logout:
      'PC-logoutJobSearchList_floatBannerArea_viewHistory_toviewHistoryDetail',
  },
} as const;

export const USER_CLICK_HISTORYLIST = {
  param: 'usrclk_searchList',
  value: {
    login:
      'PC-loginJobSearchList_floatBunnerArea_viewHistory_toViewHistoryList',
    logout:
      'PC-logoutJobSearchList_floatBunnerArea_viewHistory_toViewHistoryList',
  },
} as const;

export const USER_CLICK_SEARCHCONDITION = {
  param: 'usrclk_searchList',
  value: {
    login:
      'PC-loginJobSearchList_floatBannerArea_searchHistory_toSearchHistoryDetail',
    logout:
      'PC-logoutJobSearchList_floatBannerArea_searchHistory_toSearchHistoryDetail',
  },
} as const;

export const USER_CLICK_RECOMMENDJOBLIST = {
  param: 'usrclk_searchList',
  value: {
    login:
      'PC-loginJobSearchList_floatBannerArea_savedContidions_toSavedConditionDetail',
    logout:
      'PC-loginJobSearchList_floatBannerArea_savedContidions_toSavedConditionDetail',
  },
} as const;

export const USER_CLICK_SAVEDCONDITIONLIST = {
  param: 'usrclk_searchList',
  value: {
    login:
      'PC-loginJobSearchList_floatBannerArea_savedContidions_toSavedConditionList',
    logout:
      'PC-loginJobSearchList_floatBannerArea_savedContidions_toSavedConditionList',
  },
} as const;

export const USER_CLICK_BOOKMARKLIST = {
  param: 'usrclk_searchList',
  value: {
    login: 'PC-loginJobSearchList_floatBunnerArea_bookmark_toBookmarkedList',
    logout: 'PC-logoutJobSearchList_floatBunnerArea_bookmark_toBookmarkedList',
  },
} as const;

export const USER_CLICK_JOBDETAIL = {
  param: 'usrclk_searchList',
  value: {
    login:
      'PC-loginJobSearchList_floatBannerArea_bookmark_toBookmarkedJobDetail',
    logout:
      'PC-logoutJobSearchList_floatBannerArea_bookmark_toBookmarkedJobDetail',
  },
} as const;
